import {inject, reactive} from "vue";
import {parseDate, checkDayToDay} from "@/utils/changeDate";
import {useDataFormStore} from "@/stores/form";
import {getArrayOfRules} from "@/utils/getDataForm";
import {debounce} from "@/utils/setDebounce";
import {ref} from "vue";
import {ADDRESS} from "@/remotes";

const SUNDAY = 0;
const WITH_START_TIME = "09:00";
const BEFORE_START_TIME = "12:00";

// Инициализируем лист адресов забора
const fromAddressList = ref({});
const toAddressList = ref({});
const addressFromDropdown = ref()
const addressToDropdown = ref()

export default {

    setup() {
        const dataForm = useDataFormStore();

        const options = ["Отправитель", "Получатель", "Третье лицо"];

        const citiesArr = inject('citiesArr', []);


        // Получаем адреса для  забора с API и подставляем в список (значение, город отправки)
        async function getFromAddressList(value, cityFrom) {
            if (value.length > 1) {
                try {
                    const {data} = await ADDRESS.post('4_1/rs/suggest/address', {
                        query: value,
                        locations: [{"city": cityFrom}],
                        restrict_value: true
                    });
                    fromAddressList.value = data.suggestions;

                    if (fromAddressList.value.length < 1) {
                        fromAddressList.value[0] = {
                            disabled: "true",
                            class: "disable-notice",
                            value: "Нет результатов"
                        };

                        addressFromDropdown.value.handleOpen()
                    } else {
                        fromAddressList.value.unshift({
                            disabled: "true",
                            class: "disable-notice",
                            value: "Выберите нужный адрес"
                        });
                        addressFromDropdown.value.handleOpen()
                    }
                } catch (e) {
                    console.log(e);
                }
            } else {
                addressFromDropdown.value.handleClose()
            }

        }

        // Получаем адреса для получателя с API и подставляем в список (значение, город отправки)
        async function getToAddressList(value, cityTo) {
            if (value.length > 1) {
                try {
                    const {data} = await ADDRESS.post('4_1/rs/suggest/address', {
                        query: value,
                        locations: [{"city": cityTo}],
                        restrict_value: true
                    });
                    toAddressList.value = data.suggestions;
                    if (toAddressList.value.length < 1) {
                        toAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Нет результатов"};
                        addressToDropdown.value.handleOpen()
                    } else {
                        toAddressList.value.unshift({
                            disabled: "true",
                            class: "disable-notice",
                            value: "Выберите нужный адрес"
                        });
                        addressToDropdown.value.handleOpen()
                    }
                } catch (e) {
                    console.log(e);
                }
            } else {
                addressToDropdown.value.handleClose()
            }
        }

        // Создаем задержку запроса в 1 секунду
        const getFromAddressDebounce = debounce(getFromAddressList, 500)
        const getToAddressDebounce = debounce(getToAddressList, 500)

        const time = reactive({
            cargoPickup: {
                with: {
                    start: WITH_START_TIME,
                    end: "21:00",
                },
                before: {
                    start: BEFORE_START_TIME,
                    end: "24:00",
                },
                isDayToDay: false,
            },
            cargoDelivery: {
                with: {
                    start: WITH_START_TIME,
                    end: "21:00",
                },
                before: {
                    start: BEFORE_START_TIME,
                    end: "24:00",
                },
                isDayToDay: false,
            },
            step: "00:10",
            // applicationTimeIsOver: "13:00",
        });

        function changeDate(stateName) {
            changeStartTime(stateName);
        }

        function changeStartTime(stateName) {
            const timeName = getTimeName(stateName);
            time[timeName].with.start = WITH_START_TIME;
            time[timeName].before.start = BEFORE_START_TIME;

            time[timeName].isDayToDay = checkDayToDay(
                dataForm.applicationCargoPickup[stateName]
            );

            if (!time[timeName].isDayToDay) {
                return;
            }
            if (
                (dataForm.sender.cityFrom === "Челябинск" ||
                    dataForm.sender.cityFrom === "Екатеринбург") &&
                new Date().getHours() >= 12 &&
                dataForm.cargoInformation.cargoWeight > 30
            ) {
                dataForm.cargoInformation.cargoWeight = 30;
            }

            const currentTime = roundUpTheTime(getStringCurrentTime());

            time[timeName].with.start =
                getStringCurrentTime() > time[timeName].with.start
                    ? currentTime
                    : WITH_START_TIME;

            const timeWithInterval = checkTimeInterval(time[timeName].with.start);
            time[timeName].before.start = timeWithInterval;

            dataForm.applicationCargoPickup[getEndTimeName(stateName)] = !dataForm
                .applicationCargoPickup[getEndTimeName(stateName)].length
                ? dataForm.applicationCargoPickup[getEndTimeName(stateName)]
                : timeWithInterval;
            const startTimeName = getStartTimeName(stateName);
            if (!dataForm.applicationCargoPickup[startTimeName].length) {
                return;
            }
            dataForm.applicationCargoPickup[startTimeName] = currentTime;
        }


        // const checkDayToDay = (stateName) => {
        //   const selectedDay = new Date(getStringDate(dataForm.applicationCargoPickup[stateName]));
        //   selectedDay.setDate(selectedDay.getDate() + 1);
        //   return getStringDate(new Date()) === getStringDate(selectedDay);
        // };

        // const getStringDate = (date) => date.toISOString().slice(0, 10);

        function roundUpTheTime(time) {
            const hoursNumber = Number(time.slice(0, 2));
            let minutes = Math.ceil(Number(time.slice(3, 5)) / 10) * 10;
            let hour = hoursNumber;
            if (minutes === 60) {
                hour++;
                minutes = 0;
            }

            return `${parseDate(hour)}:${parseDate(minutes)}`;
        }

        const isApplicationTimeIsOver = () =>
            // getStringCurrentTime() >= time.applicationTimeIsOver;
            getStringCurrentTime() >= dataForm.getApplicationTimeIsOver;

        function getStringCurrentTime() {
            const date = new Date();
            const hour = date.getHours();
            const minutes = date.getMinutes();

            return `${parseDate(hour)}:${parseDate(minutes)}`;
        }

        function changeStartTimeBefore(stateName) {
            const endTimeName = stateName.replace("Start", "End");
            const timeFromTheInterval = checkTimeInterval(
                dataForm.applicationCargoPickup[stateName]
            );

            const timeName = getTimeName(stateName);

            time[timeName].before.start =
                timeFromTheInterval.length > 3
                    ? timeFromTheInterval
                    : BEFORE_START_TIME;

            if (
                dataForm.applicationCargoPickup[endTimeName].length &&
                dataForm.applicationCargoPickup[endTimeName] < timeFromTheInterval
            ) {
                dataForm.applicationCargoPickup[endTimeName] = timeFromTheInterval;
            }
        }

        function isPortCity(cityName = 'чел') {
            let city = citiesArr.value.find(city => city.name == cityName)

            if (city?.deliveryPickupCategory === 2) {
                dataForm.applicationCargoPickup.deliveryToTheAddress = true
                dataForm.applicationCargoPickup.addressConsignee=' '
                return true
            }

            return false
        }

        function checkIncludingLunch(stateName) {
            if (
                !dataForm.applicationCargoPickup[getStartTimeLunchName(stateName)]
                    .length &&
                !dataForm.applicationCargoPickup[getEndTimeLunchName(stateName)].length
            ) {
                return;
            }
            includingLunch(getEndTimeLunchName(stateName));
        }

        function includingLunch(stateName) {
            const startTimeLunchName = stateName.replace("end", "start");
            const startTimeName = getStartTimeName(stateName);
            const endTimeName = getEndTimeName(stateName);

            if (
                !dataForm.applicationCargoPickup[startTimeLunchName].length ||
                (!dataForm.applicationCargoPickup[startTimeName] &&
                    !dataForm.applicationCargoPickup[endTimeName])
            ) {
                return;
            }

            if (
                checkTimeLunchIn(startTimeName, endTimeName, startTimeLunchName) ||
                checkTimeLunchOut(
                    startTimeName,
                    endTimeName,
                    startTimeLunchName,
                    stateName
                )
            ) {
                const hours = 3;
                const cargoEndTime = `${parseDate(
                    getHoursNumber(dataForm.applicationCargoPickup[stateName]) + hours
                )}:${dataForm.applicationCargoPickup[stateName].slice(3, 5)}`;
                const provenCargoEndTime =
                    cargoEndTime > "24:00" ||
                    dataForm.applicationCargoPickup[endTimeName] === "00:00"
                        ? dataForm.applicationCargoPickup[endTimeName]
                        : cargoEndTime === "24:00"
                            ? "00:00"
                            : cargoEndTime;

                if (
                    dataForm.applicationCargoPickup[endTimeName].length &&
                    dataForm.applicationCargoPickup[startTimeName].length
                ) {
                    dataForm.applicationCargoPickup[endTimeName] =
                        dataForm.applicationCargoPickup[endTimeName] > provenCargoEndTime
                            ? dataForm.applicationCargoPickup[endTimeName]
                            : provenCargoEndTime;
                    return;
                }
            }
        }

        const getHoursNumber = (time) => Number(time.slice(0, 2));

        const getTimeName = (stateName) =>
            stateName.toLowerCase().indexOf("delivery") >= 0
                ? "cargoDelivery"
                : "cargoPickup";

        const getStartTimeName = (stateName) =>
            stateName.indexOf("Delivery") >= 0
                ? "cargoStartTimeDelivery"
                : "cargoStartTimePickup";

        const getEndTimeName = (stateName) =>
            stateName.toLowerCase().indexOf("delivery") >= 0
                ? "cargoEndTimeDelivery"
                : "cargoEndTimePickup";

        const getStartTimeLunchName = (stateName) =>
            stateName.indexOf("Delivery") >= 0
                ? "startTimeLunchBreakDelivery"
                : "startTimeLunchBreak";

        const getEndTimeLunchName = (stateName) =>
            stateName.indexOf("Delivery") >= 0
                ? "endTimeLunchBreakDelivery"
                : "endTimeLunchBreak";

        const checkTimeLunchIn = (startTimeName, endTimeName, startTimeLunchName) =>
            dataForm.applicationCargoPickup[startTimeName] <=
            dataForm.applicationCargoPickup[startTimeLunchName] &&
            dataForm.applicationCargoPickup[endTimeName] >
            dataForm.applicationCargoPickup[startTimeLunchName];

        const checkTimeLunchOut = (
            startTimeName,
            endTimeName,
            startTimeLunchName,
            endTimeLunchName
        ) =>
            dataForm.applicationCargoPickup[startTimeName] >
            dataForm.applicationCargoPickup[startTimeLunchName] &&
            dataForm.applicationCargoPickup[startTimeName] <
            dataForm.applicationCargoPickup[endTimeLunchName];

        function checkTimeInterval(time) {
            const timeHour = Number(time.slice(0, 2)) + 3;
            const timeMinute = time.slice(3, 5);

            return `${parseDate(timeHour)}:${timeMinute}`;
        }

        const checkCity = () =>
            dataForm.sender.cityFrom === "Челябинск" ||
            dataForm.sender.cityFrom === "Екатеринбург";

        const checkHour = () => new Date().getHours() >= 12;

        return {
            isPortCity,
            fromAddressList,
            toAddressList,
            dataForm,
            options,
            time,
            getArrayOfRules,
            checkDayToDay,
            checkCity,
            checkHour,

            addressFromDropdown,
            addressToDropdown,
            changeDate,
            includingLunch,

            changeStartTime: function (stateName) {
                changeStartTimeBefore(stateName);
                checkIncludingLunch(stateName);
            },

            changeEndTime: function (stateName) {
                checkIncludingLunch(stateName);
            },

            chengeTimeLunch: function (stateName) {
                includingLunch(stateName);
            },

            datePickerOptions: function (date) {
                const today = new Date();
                today.setDate(
                    isApplicationTimeIsOver() ? today.getDate() : today.getDate() - 1
                );

                return date < today || date.getDay() === SUNDAY;
            },
            clickFromAddress: function () {
                if (dataForm.applicationCargoPickup.addressCargoPickup.length <= 1) {
                    addressFromDropdown.value.handleClose()
                } else {
                    addressFromDropdown.value.handleOpen()
                }
            },

            getFromAddress: function () {
                if (dataForm.applicationCargoPickup.addressCargoPickup.length <= 1) {
                    addressFromDropdown.value.handleClose();
                    fromAddressList.value = [];
                } else {
                    addressFromDropdown.value.handleOpen()
                    fromAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Поиск..."};
                }
                getFromAddressDebounce(dataForm.applicationCargoPickup.addressCargoPickup, dataForm.sender.cityFrom)
            },
            setFromAddress: function (value) {
                dataForm.applicationCargoPickup.addressCargoPickup = value
            },
            clickToAddress: function () {
                // timerTo.value = false
                // timeoutTo.value = null
                if (dataForm.applicationCargoPickup.addressConsignee.length <= 1) {
                    addressToDropdown.value.handleClose()
                } else {
                    addressToDropdown.value.handleOpen()
                }
            },
            getToAddress: function () {
                if (dataForm.applicationCargoPickup.addressConsignee.length <= 1) {
                    addressToDropdown.value.handleClose();
                    toAddressList.value = [];
                } else {
                    addressToDropdown.value.handleOpen()
                    toAddressList.value[0] = {disabled: "true", class: "disable-notice", value: "Поиск..."};
                }
                getToAddressDebounce(dataForm.applicationCargoPickup.addressConsignee, dataForm.consignee.cityTo)
            },
            setToAddress: function (value) {
                dataForm.applicationCargoPickup.addressConsignee = value
            },
            cargoPickupStartTime: () => {
                return checkTimeInterval(time.cargoPickup.with.end);
            },

            cargoDeliveryStartTime: () => {
                return checkTimeInterval(time.cargoDelivery.with.end);
            },
        };
    },
};
